/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: '5780bad7-cda8-465e-9404-7c47014fd88c', // onestudio kdbrk
        // clientId: 'f6dcebce-6f8f-471e-9839-1bda9290a438', // onestudio ka
        // clientId: '4f8cd7b4-2239-4cfe-bff3-d0ae80cc1186', // This is the ONLY mandatory field that you need to supply.
        authority: 'https://login.microsoftonline.com/kdbrk3.onmicrosoft.com', // Replace the placeholder with your tenant subdomain
        // authority: 'https://login.microsoftonline.com/ka.onmicrosoft.com', // Replace the placeholder with your tenant subdomain
        redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
            /**
             * Below you can configure MSAL.js logs. For more information, visit:
             * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
             */
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: [
        // "https://kdbrk-historicaldataservice-dev.azurewebsites.net/user_impersonation",
        "https://app-c10002prod-hds.azurewebsites.net/user_impersonation"
    ],
    // scopes: ["https://kdbrk-historicaldataservice-dev.azurewebsites.net/user_impersonation"],
};